<template>
  <div>
    <!--顶部 登录联系我们-->
    <div class="head-info-bg">
      <div class="head-info-main">
        <div class="info-menu">
          <div class="language" @click="changeLangEvent">
            <i class="el-icon-caret-bottom"></i>{{ $t("common.language") }}
          </div>

          <div v-show="!isLogin" class="login-tag">
            <span @click="login" class="login">{{this.$t('common.login')}}</span>
            <span @click="register" class="register">{{this.$t('common.Register')}}</span>
            <!--<router-link to="/login" class="login">登录</router-link>-->
            <!--<router-link to="/register" class="register">注册</router-link>-->
          </div>

          <div v-show="isLogin" class="login-tag">
            <el-dropdown @command="handleCommand" trigger="click">
              <div class="el-dropdown-link user-name">
                {{nickname}}<i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-wallet" command="userCenter">{{$t('common.UserCenter')}}</el-dropdown-item>
                <el-dropdown-item icon="el-icon-wallet" command="recharge">{{$t('common.Recharge')}}</el-dropdown-item>
                <el-dropdown-item icon="el-icon-circle-close" command="exit">{{$t('common.Logout')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <span class="collection" @click="contact">{{ $t("common.contact") }} </span>
          <!--/*分享*/-->
          <ul class="socialmedia-widget">
            <li><a href="mailto:sales@mrtlab.com" class="mail" title="Email"></a></li>
            <li><a target="_blank" href="https://www.facebook.com/mrtlab/?ref=aymt_homepage_panel" class="facebook" title="Facebook"></a></li>
            <li><a target="_blank" href="https://twitter.com/LabMrt" class="twitter" title="Twitter"></a></li>
            <li><a target="_blank" href="https://plus.google.com/u/0/117678288059165200158/posts" class="googleplus" title="Google+"></a></li>
            <li><a target="_blank" href="https://www.youtube.com/channel/UCk4K096WZR_0FtaayFlewmg" class="youtube" title="Youtube"></a></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="head-contain">
      <div class="head-bg">
        <router-link to="/"><img src='@/assets/img/mrt_logo_black.png' class="logo"/></router-link>
        <div class="menu-bg">
          <div class="menu-bar-box" @click="handleMenuClick">
            <span class="menu-bar"></span>
          </div>
          <ul class="menu-list" id="nav" ref="menuListRef">
            <!--<li :id="'navIndex'+index" v-for="(item,index) in navList"-->
                <!--@click="routerLink(item.path,index )"> {{ item.title }}-->
            <!--</li>-->
            <li class="menu-out"> <router-link to="/">{{this.$t('common.home')}}</router-link></li>
            <li class="menu-out"> <router-link to="/industryNews">{{this.$t('common.IndustryNews')}}</router-link></li>
            <li class="menu-out"> <router-link to="/tutorial">{{this.$t('common.TutorialsData')}}</router-link>
              <ul class="second-menu">
                <li ><router-link to="/submission">{{this.$t('common.PaidSubmission')}}</router-link></li>
              </ul>
            </li>
            <li class="menu-out"> <router-link to="/Software">{{this.$t('common.Software')}}</router-link></li>

            <li class="menu-out" @click="Products">{{this.$t('common.Products')}}</li>

            <li class="menu-out" @click="Users">{{this.$t('common.center')}}
              <ul class="second-menu">
                <li @click.stop="Support">{{this.$t('common.Support')}}</li>
                <li @click.stop="BuyProduct">{{this.$t('common.Buy')}}</li>
              </ul>
            </li>
            <li class="menu-out" @click="Taobao">{{this.$t('common.taobao')}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--菜单导航-->
    <!--<div class="menu-bg">
      <ul>
        <li :id="'navIndex'+index" v-for="(item,index) in navList"
            @click="routerLink(item.path,index )"> {{ item.title }}
        </li>
        <li class="menu-out" @click="Firmware"> {{this.$t('common.Firmware')}}</li>
        <li class="menu-out" @click="Support">{{this.$t('common.Support')}}</li>
        <li class="menu-out" @click="Products">{{this.$t('common.Products')}}</li>
        <li class="menu-out"  @click="Users">{{this.$t('common.userCenter')}}</li>
      </ul>
    </div>-->
    <!--登录弹出页面-->
    <el-dialog :title="$t('common.login')" custom-class="dialog-style" :visible.sync=this.$store.state.dialogLoginVisible
               :before-close="loginClose">
      <div class="form-bg">
        <el-form :model="loginForm" status-icon :rules="loginRules" ref="loginForm" label-width="125px"
                 class="demo-ruleForm">
          <el-form-item :label="$t('userInfo.username')" prop="username">
            <el-input type="text" v-model="loginForm.username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('userInfo.password')" prop="pass">
            <el-input type="password" v-model="loginForm.pass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="loginSubmit('loginForm')">{{this.$t('common.login')}}</el-button>
            <el-button type="success" plain @click="goRegister()">{{this.$t('common.Register')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!--注册弹出页面-->
    <el-dialog :title="$t('common.Register')" custom-class="dialog-style"  :visible.sync=this.$store.state.dialogRegisterVisible
               :before-close="registerClose">
      <div class="form-bg">
        <el-form :model="registerForm" status-icon :rules="registerRules" ref="registerForm" label-width="125px"
                 class="demo-ruleForm">
          <el-form-item :label="$t('userInfo.username')" prop="username">
            <el-input type="text" v-model="registerForm.username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('userInfo.Nickname')" prop="nickname">
            <el-input type="text" v-model="registerForm.nickname" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('userInfo.password')" prop="pass">
            <el-input type="password" v-model="registerForm.pass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('userInfo.confirmPWD')" prop="checkPass">
            <el-input type="password" v-model="registerForm.checkPass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('userInfo.code')" prop="checkCode">
            <el-input type="text" v-model="registerForm.checkCode" autocomplete="off" class="code-input"></el-input>
            <img :src="codeImg" @click="refreshCode" class="img-code"/>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="registerSubmit('registerForm')">{{this.$t('common.Register')}}</el-button>
            <el-button type="success" plain @click="goLogin()">{{this.$t('common.login')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!--充值弹出页面-->
    <el-dialog :title="$t('common.RechargeAccount')" custom-class="dialog-style"  :visible.sync="dialogRechargeVisible">
      <el-form class="recharge-form" :model="rechargeForm" label-width="100px">
        <el-form-item :label="$t('common.RechargeMethods')" class="label-style">
          <div class="radio-style">
            <el-radio v-model="radio" label="usd">{{this.$t('common.USD')}}</el-radio>
            <el-radio v-model="radio" label="rmb">{{this.$t('common.RMB')}}</el-radio>
          </div>
        </el-form-item>
        <el-form-item :label="this.$t('common.Balance')" class="label-style">
          <div class="price-style">
            <span>{{rechargeForm.overUsd}}{{this.$t('common.USD')}}</span>
            <span>{{rechargeForm.overRmb}}{{this.$t('common.RMB')}}</span>
            <span>{{rechargeForm.overGold}}{{this.$t('common.Coins')}}</span>
          </div>
        </el-form-item>
        <el-form-item :label="this.$t('common.amount')" class="label-style">
          <div class="price-style">
            <el-input type="number" min="0" v-model="rechargeForm.price"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetRecharge('rechargeForm')">{{this.$t('common.Cancel')}}</el-button>
        <el-button type="success" @click="rechargeSubmit('rechargeForm')">{{this.$t('common.Ok')}}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import axios from '../axios'
  import elementEnLocale from 'element-ui/lib/locale/lang/en'
  import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
  import ElementUI from 'element-ui'
  import locale from 'element-ui/lib/locale'

  export default {
    name: 'headerComponent',
    data() {
      //登录表单验证
      var loginUsername = (rule, value, callback) => {
        if (value === '') {
            callback(new Error(this.$t('message.enterName')));
          } else {
            callback();
          }
      };
      var loginPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterPWD')));
        } else {
          if (this.loginForm.checkPass !== '') {
            this.$refs.loginForm.validateField('checkPass');
          }
          callback();
        }
      };
      //注册表单验证
      var registerUsername = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterName')));
        } else {
          callback();
        }
      };
      var registerPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterPWD')));
        } else {
          if (this.registerForm.checkPass !== '') {
            this.$refs.registerForm.validateField('checkPass');
          }
          callback();
        }
      };
      var registerPass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.pwdAgain')));
        } else if (value !== this.registerForm.pass) {
          callback(new Error(this.$t('message.pwdMatch')));
        } else {
          callback();
        }
      };
      var registerCheckCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterCode')));
        } else {
          callback();
        }
      };
      return {
        logoUrl:require('@/assets/homepage/mrt_logo.png'),
        navList: [
          {title: this.$t('common.home'), path: '/', uri: 'home'},
          {title: this.$t('common.IndustryNews'), path: '/industryNews', uri: 'news'},
          {title: this.$t('common.TutorialsData'), path: '/tutorial', uri: 'tutorial'},
          // {title: this.$t('common.IndustryTalk'), path: '/industryTalk', uri: 'news'},
          {title: this.$t('common.Software'), path: '/software', uri: 'software'},
          // {title: '图片资料', path: '/imgList',uri:'picture'},
          // {title: this.$t('common.Website'), path: '/website', uri: 'website'},
          // {title: this.$t('common.PaidSubmission'), path: '/submission'},
        ],
        nickname: '',
        isLogin: false,
        dialogLoginVisible: false,
        dialogRegisterVisible: false,
        dialogRechargeVisible: false,
        rechargeForm: {
          overUsd: '0',
          overRmb: '0',
          overGold: '0',
          price: '',
        },
        radio: '',
        loginForm: {
          username: '',
          pass: '',
        },
        loginRules: {
          username: [
            {validator: loginUsername, trigger: 'blur'}
          ],
          pass: [
            {validator: loginPass, trigger: 'blur'}
          ],
        },
        registerForm: {
          username: '',
          nickname: '',
          pass: '',
          checkPass: '',
          checkCode: ''
        },
        codeImg: '',
        uuid: '',
        registerRules: {
          username: [
            {validator: registerUsername, trigger: 'blur'}
          ],
          pass: [
            {validator: registerPass, trigger: 'blur'}
          ],
          checkPass: [
            {validator: registerPass2, trigger: 'blur'}
          ],
          checkCode: [
            {validator: registerCheckCode, trigger: 'blur'}
          ]
        },
      }
    },
    created: function () {
      this.init();
      this.refreshCode();
      //判断页面中文/英文 显示对应LOGO图片
      var lang = this.$store.state.lang
      if(lang==='en'){
        this.logoUrl=require('@/assets/homepage/mrt_logo.png');
      }else if(lang==='zh'){
        this.logoUrl= require('@/assets/homepage/mrt_logo.png');
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.menuHover();
      })
      // 手机端点击文档（#nav除外）关闭导航栏
      const w = document.documentElement.clientWidth || document.body.clientWidth
      if (w < 768) {
        const navDom = document.getElementById('nav')
        document.onclick = function () {
          navDom.style.display = 'none'
        }
        navDom.onclick = function (e) {
          e.stopPropagation()
        }
      }
    },

    methods: {
      // 页面初始化方法
      init() {
        this.nickname = localStorage.getItem('nickname');
        if (this.nickname !== '' && this.nickname !== null) {
          this.isLogin = true;
        }
        var lang = this.$store.state.lang
        this.$i18n.locale = lang
        lang === 'zh' ? locale.use(elementZhLocale) : locale.use(elementEnLocale)
        this.navList = [
          {title: this.$t('common.home'), path: '/'},
          {title: this.$t('common.IndustryNews'), path: '/industryNews'},
          {title: this.$t('common.TutorialsData'), path: '/tutorial'},
          // {title: this.$t('common.IndustryTalk'), path: '/industryTalk'},
          {title: this.$t('common.Software'), path: '/software'},
          // {title: '图片资料', path: '/imgList',uri:'picture'},
          // {title: this.$t('common.Website'), path: '/website'},
          // {title: this.$t('common.PaidSubmission'),path: '/submission'},
        ];
      },
      //点击导航登录按钮
      login() {
        this.$store.commit('login_dialog');
      },
      //点击导航注册按钮
      register() {
        this.$store.commit('register_dialog');
      },
      //联系我们
      contact(){
        // this.$router.push('/contactUs');
        window.open('https://info.mrtlab.com/prodindex.htm#mrtselladds','_black')
        var lang = this.$store.state.lang
        if(lang==='en'){
          window.open('https://us.mrtlab.com/prodindex.htm#mrtselladds','_black');
        }else if(lang==='zh'){
          window.open('https://info.mrtlab.com/prodindex.htm#mrtselladds','_black')
        }
      },
      // 加入收藏 兼容360和IE6 
      collection(obj, opts) {
        var _t, _u;
        if (typeof opts != 'object') {
          _t = document.title;
          _u = location.href;
        } else {
          _t = opts.title || document.title;
          _u = opts.url || location.href;
        }
        try {
          window.external.collection(_u, _t);
        } catch (e) {
          if (window.sidebar) {
            obj.href = _u;
            obj.title = _t;
            obj.rel = 'sidebar';
          } else {
            this.$message({
              type: 'error',
              title: this.$t("message.Error"),
              message: this.$t('common.collect'),
              showClose: true,
              offset:300,
              duration:3000,
            });
          }
        }

      },
       // 退出登录
      handleCommand(command) {
        if (command === 'exit') {
          localStorage.removeItem('loginToken');
          localStorage.removeItem('nickname');
          //拆出cookies存为数组
          var cookiesArr=document.cookie.split(";");

          //循环数组
          for(let i in cookiesArr){
            //用=拆分字符串，取出cookie key，存为数组
            var cookieItem = cookiesArr[i].trim();//去除首尾空格
            var cookieKey=cookieItem.split("=")[0];
            if(cookieKey==="token" ){ //判断cookie 是否存在token
              document.cookie = "token=;expires=-1"
            }
            if(cookieKey==="nickname" ){//判断cookie 是否存在nickname
              document.cookie = "nickname=;expires=-1"
            }
          }
          // 退出登录，页面刷新
          window.location.reload()
        } else if (command === 'recharge') {
          let _this = this;
          this.dialogRechargeVisible = true;
          axios.get(this.$store.state.apiBasePath + "/user/info")
            .then(function (res) {
              var resData = res.data;
              if (resData.code === 200) {
                _this.rechargeForm.overUsd = resData.data.usd;
                _this.rechargeForm.overRmb = resData.data.rmb;
                _this.rechargeForm.overGold = resData.data.gold;
              }
            });
        }else if (command === 'userCenter') {
          sessionStorage.setItem('centerMenu', "0");
          this.$router.push('/userCenter');
        }
      },
      // 点击切换语言
      changeLangEvent() {
        var lang = this.$store.state.lang
        // 中英语种互换
        lang = lang === 'zh' ? 'en' : 'zh';
        // 设置语言
        this.$i18n.locale = lang;
        lang === 'zh' ? locale.use(elementZhLocale) : locale.use(elementEnLocale)
        // 保存当前语种
        this.$store.commit('langUpdate', lang)
        window.location.reload();
      },
      // 页面初始化导航高亮
      menuHover() {
        var navIndex = sessionStorage.getItem('menuIndex');
        var nav = document.getElementById('navIndex' + navIndex);
        if (nav != null) {
          nav.className = 'hover';
        }
      },
      /**导航跳转高亮
       * 路由跳转
       * @param index
       * @param link
       */
      routerLink(path, index) {
        //页面导航高亮
        var localUri = this.navList[index].uri;
        sessionStorage.setItem('type1', localUri);
        sessionStorage.setItem('menuIndex', index);
        // 路由跳转
        if (path == '/submission') {
          // sessionStorage.setItem('type1', 'submission');
          // window.location.href = '/submission';
          // return;
          this.$router.push(path);
          window.location.reload();
          return;
        }
        this.$router.push(path);
      },
      // 充值提交
      rechargeSubmit() {
        let price = this.rechargeForm.price;
        let token = localStorage.getItem('loginToken');
        let radio = this.radio;
        if (price == '') {
          this.$message({
            type: 'error',
            title: this.$t('message.Error'),
            message: this.$t('message.RechargeAmount'),
            showClose: true,
            offset:300,
            duration:3000,
          });
        } else if (price <= 0) {
          this.$message({
            type: 'error',
            title: this.$t('message.Error'),
            message: this.$t('message.PriceVerification'),
            showClose: true,
            offset:300,
            duration:3000,
          });
        } else if (radio == '') {
          this.$message({
            type: 'error',
            title: this.$t('message.Error'),
            message: this.$t('message.RechargeMethod'),
            showClose: true,
            offset:300,
            duration:3000,
          });
        } else {
          window.open(this.$store.state.apiBasePath + '/pay/recharge?payment=' + radio + '&money=' + price + '&token=' + token, '_target');
        }
      },
      resetRecharge() {
        this.rechargeForm.price = '';
        this.radio = '';
        this.dialogRechargeVisible = false;
      },
      //登录提交
      loginSubmit(formName) {
        let _this = this;
        let username = this.loginForm.username;
        let password = this.loginForm.pass;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.post(this.$store.state.apiBasePath + "/login", {
              username: username,
              password: password
            }).then(function (res) {
              var data = res.data;
              if (data.code == 200) {
                _this.dialogLoginVisible = false;
                localStorage.setItem('loginToken', data.token);
                localStorage.setItem('nickname', data.nickname);
                // 登陆成功刷新页面
                _this.$store.commit('login_dialog');
                window.location.reload()
                // window.location.href='#/';
              } else {
                _this.$notify.error({
                  title: _this.$t('message.Error'),
                  message: res.data.msg,
                  duration: 2000
                });
              }
            })
          } else {
            return false;
          }
        });
      },
      //登录关闭回调
      loginClose() {
        this.$store.commit('login_dialog');
      },
      //去注册
      goRegister() {
        this.$store.commit('login_dialog');
        this.$store.commit('register_dialog');
      },
      //注册提交
      registerSubmit(formName) {
        let _this = this;
        let username = this.registerForm.username;
        let nickname = this.registerForm.nickname;
        let password = this.registerForm.pass;
        let code = this.registerForm.checkCode;
        let uuid = this.uuid;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (nickname === '' || nickname == null) {
              nickname = username;
            }
            axios.post(this.$store.state.apiBasePath + "/register", {
              username: username,
              nickname: nickname,
              password: password,
              code: code,
              uuid: uuid,
            }).then(function (res) {
              var data = res.data;
              if (data.code == 200) {
                _this.dialogRegisterVisible = false;
                _this.dialogLoginVisible = true;
                _this.$notify.success({
                  title: _this.$t('message.Success'),
                  message: _this.$t('message.gologin'),
                  duration: 2000,
                  onClose: function () {
                    _this.$store.commit('login_dialog');
                    _this.$store.commit('register_dialog');
                  }
                });
                // _this.$router.push('/login')
              } else {
                _this.$notify.error({
                  title: _this.$t('message.Error'),
                  message: res.data.msg,
                  duration: 2000
                });
              }
            })
          } else {
            return false;
          }
        });
      },
      getUuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      // 点击刷新验证码
      refreshCode() {
        this.uuid = this.getUuid();
        // this.codeImg = 'http://hdd.mrtlab.com:8080/api/captcha.jpg?uuid=' + this.uuid
        this.codeImg = this.$store.state.apiBasePath + 'captcha.jpg?uuid=' + this.uuid
      },
      //去登录
      goLogin() {
        this.$store.commit('register_dialog');
        this.$store.commit('login_dialog');
      },
      //注册关闭回调
      registerClose() {
        this.$store.commit('register_dialog');
      },
      // 跳转固件云页面
      Firmware(){
        var token=localStorage.getItem('loginToken');
        var nickname=localStorage.getItem('nickname');
        // console.log(token);
        var url='https://hdd.mrtlab.com/firmware';
        if(token !='' && token !=null){
          url+='?token='+token+'&nickname='+nickname;
        }
        window.open(url,'_black')
      },
      //跳转到技术支持
      Support(){
        window.open('https://vip.mrtlab.com/suptask.jsp','_black')
        var lang = this.$store.state.lang
        if(lang==='en'){
          window.open('https://vip.mrtlab.com/en/suptask.jsp','_black');
        }else if(lang==='zh'){
          window.open('https://vip.mrtlab.com/suptask.jsp','_black')
        }
      },
      //跳转到产品购买
      BuyProduct(){
        window.open('https://cn.mrtlab.com/order','_black')
        var lang = this.$store.state.lang
        if(lang==='en'){
          window.open('https://en.mrtlab.com/order','_black');
        }else if(lang==='zh'){
          window.open('https://cn.mrtlab.com/order','_black')
        }
      },
      //跳转到产品专栏
      Products(){
        // 默认跳转到MRT Express
        this.navigateToProduct('express');
      },
      // 导航到指定产品
      navigateToProduct(productType) {
        // 存储选择的产品类型到sessionStorage
        sessionStorage.setItem('selectedProduct', productType);
        // 导航到产品页面
        this.$router.push('/products');
      },
      Users(){
        window.open('https://vip.mrtlab.com/user.jsp','_black')
        var lang = this.$store.state.lang
        if(lang=='en'){
          window.open('https://vip.mrtlab.com/en/user.jsp','_black');
        }else if(lang=='zh'){
          window.open('https://vip.mrtlab.com/user.jsp','_black')
        }

      },
      Taobao(){
        window.open('https://mrtlab.taobao.com','_black')

      },
      // 新增手机端导航点击事件
      handleMenuClick (e) {
        const w = document.documentElement.clientWidth || document.body.clientWidth
        if (w > 767) return
        let dis = document.defaultView.getComputedStyle(this.$refs.menuListRef).display || this.$refs.menuListRef.currentStyle[display]
        if (dis === 'block') {
          this.$refs.menuListRef.style.display = 'none'
        }
        if (dis === 'none') {
          this.$refs.menuListRef.style.display = 'block'
        }
        e.stopPropagation();
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import '../assets/css/varibles';
  @import '../assets/css/mixins';
  // head开始
  .head-info-bg {
    height: 40px;
    line-height: 40px;
    background: #f2f2f2;
    border-bottom: 1px solid #f2f2f2;
    font-size: 14px;
    .head-info-main {
      width: 1170px;
      margin: 0 auto;
    }
    .info-menu {
      display: flex;
      justify-content: flex-end;
    }
    /* 语言切换 */
    .language {
      color: #333;
      margin-right: 10px;
      &:hover {
        color: @active-color;
        cursor: pointer;
      }
    }
    /* 登录 */
    .info-menu .login-tag {
      margin-right: 10px;
      .login, .register, a {
        color: #333;
        margin: 0 5px;
      }
      .login:hover, .register:hover {
        cursor: pointer;
        color: @active-color;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      a:hover {
        color: @active-color;
      }
      .el-dropdown-link {
        cursor: pointer;
        color: #333;
      }
      .el-dropdown-link:hover {
        cursor: pointer;
        color: @active-color;
      }
      .el-icon-arrow-down {
        font-size: 12px;
      }
    }
    /* 联系我们 */
    .collection {
      color: #333;
      margin: 0 10px;
      &:hover {
        color: @active-color;
        cursor: pointer;
      }
    }
    /* 分享 */
    .socialmedia-widget {
      list-style: none outside none;
      margin: 0;
      padding: 0;
      overflow: hidden;
      li {
        background: none repeat scroll 0 0 transparent;
        float: left;
        width: 40px;
        height: 40px;
        margin: 0 !important;
        padding: 0 !important;
      }
      li a {
        background: url("../assets/homepage/social_icons.png") repeat scroll 0 0 transparent;
        display: block;
        width: 40px;
        height: 40px;
        text-indent: -9999px;
        outline: none;
        -webkit-transition: 0.3s;
        -moz-transition: 0.3s;
        -o-transition: 0.3s;
        transition: 0.3s;
      }
      a.mail {
        background-position: -560px top;
      }
      a.mail:hover {
        background-position: -560px bottom;
      }
      a.facebook {
        background-position: 0 top;
      }
      a.facebook:hover {
        background-position: 0 bottom;
      }
      a.twitter {
        background-position: -40px top;
      }
      a.twitter:hover {
        background-position: -40px bottom;
      }
      a.googleplus {
        background-position: -440px top;
      }
      a.googleplus:hover {
        background-position: -440px bottom;
      }
      a.youtube {
        background-position: -520px top;
      }
      a.youtube:hover {
        background-position: -520px bottom;
      }
    }
  }

  // 导航栏开始
  .head-contain {
    background: #fff;
    margin: 0 auto;
    border-bottom: 1px solid @border-color;
    .head-bg {
      background: #fff;
      height: 80px;
      width: 1170px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    // logo
    .logo {
      width: 233px;
      height: 70px;
    }
    // 菜单导航
    .menu-bg {
      margin: 0 0 0 20px;
      ul.menu-list {
        width:700px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      ul.menu-list li{
        position: relative;
      }
      ul.menu-list > li > ul.second-menu,
      ul.menu-list > li > ul.products-dropdown-menu {
        position: absolute;
        background: #fff;
        width: 100%;
        opacity: 0;
        transition: opacity 0.5s ease, visibility 0.5s ease;
        visibility: hidden;
        border: 1px solid @border-color;
      }
      ul.menu-list > li:hover > ul.second-menu,
      ul.menu-list > li:hover > ul.products-dropdown-menu {
        opacity: 1;
        transition: opacity 0.5s ease,visibility 0.5s ease;
        visibility: visible;
        z-index: 10;
      }
      ul.second-menu li,
      ul.second-menu li a {
        display: block;
        color: @base-color;
        width: 100%;
      }
      .menu-list li,
      .menu-list li.menu-out a {
        font-size: 16px;
        text-align: center;
        display: inline-block;
        color: @base-color;
        line-height: 60px;
        flex: 1;
        text-decoration: none;
        text-indent: 0;
        transition: all ease 0.5s;
      }
      .menu-list li.menu-out {
        line-height: 80px;
      }
      .menu-list li:hover,
      .menu-list li a:hover,
      #nav a.router-link-exact-active {
        cursor: pointer;
        color: @active-color;
        text-indent: 5px;
        transition: all ease 0.5s;
      }
      ul.menu-list li{
        position: relative;
      }
    }
  }

  // 充值弹窗
  .recharge-form {
    border: #ddd 1px solid;
    margin: 0 30px;
    .radio-style,
    .price-style {
      border-left: #ddd 1px solid;
      line-height: 60px;
      padding-left: 15px;
    }
    .radio-style .el-radio {
      width: 100px;
      display: inline-block;
      margin-right: 0;
    }
    .price-style input[type='number']{
      width: 150px;
    }
    .price-style span {
      width: 100px;
      display: inline-block;
    }

    .label-style {
      border-bottom: #ddd 1px solid;
      margin-bottom: 0 !important;
      line-height: 60px;
    }
    .label-style .el-form-item__label {
      line-height: 60px;
    }
    .label-style:last-child {
      border: none;
    }
  }

  // 登录、注册弹框样式
  .form-bg {
    width: 500px;
    .code-input {
      float: left;
      width: 215px !important;
    }
    .img-code {
      display: inline-block;
      height: 40px;
      border-radius: 3px;
      float: right;
      width: 150px;
    }
  }

  @media screen and (max-width:1024px){
    // head开始
    .head-info-bg .head-info-main {
      width: 100%;
      display: contents;
    }

    // 导航栏开始
    .head-contain {
      .head-bg {
        width: 100%;
        display: contents;
        a {
          display: block;
          padding: 10px 0;
        }
      }
      .logo {
        margin: 0 auto;
        display: block;
        width: 35%;
        height: auto;
      }
      .menu-bg {
        overflow-x: auto;
        margin: 0 auto;
        ul.menu-list {
          overflow-x: auto;
          width: 100%;
        }
      }
    }

    // 登录、注册弹窗样式
    .form-bg {
      width: 100%;
    }
    // 登录、注册、充值弹窗样式
    /deep/ .dialog-style {
      width:80%;
      .el-form-item__label {
        width: 80px !important;
      }
      .el-form-item__content {
        margin-left: 100px !important;
      }
      .code-input {width:60% !important;}
      .img-code {width:40%;}
    }
  }

  @media screen and (max-width: 1170px) {
    .head-info-bg {
      padding: 0 10px;
      .head-info-main {
        width: 100%;
      }
    }
    .head-contain {
      padding: 0 10px;
      .head-bg {
        width: 100%;
      }
      .menu-bg ul.menu-list {
        width: 500px;
      }
    }
  }

  @media screen and (max-width: 767px) {
    // head开始
    .head-info-bg {
      height: 51px;
      line-height: 51px;
      padding: 0 10px;
      .info-menu {
        justify-content: flex-start;
      }
      .socialmedia-widget {
        li {
          height: 51px;
        }
        li a {
          height: 100%;
        }
        a.mail {
          background-position: 97px top;
        }
        a.mail:hover {
          background-position: 97px bottom;
        }
        a.facebook {
          background-position: -5px top;
        }
        a.facebook:hover {
          background-position: -5px bottom;
        }
        a.twitter {
          background-position: -61px top;
        }
        a.twitter:hover {
          background-position: -61px bottom;
        }
        a.googleplus {
          background-position: 255px top;
        }
        a.googleplus:hover {
          background-position: 255px bottom;
        }
        a.youtube {
          background-position: 305px top;
        }
        a.youtube:hover {
          background-position: 305px bottom;
        }
      }
    }

    // 导航栏开始
    .head-contain {
      position: relative;
      height: 80px;
      .head-bg {
        display: flex;
      }
      // logo
      .logo {
        width: 233px;
        height: 70px;
      }
      // 菜单导航
      .menu-bg {
        flex: 1;
        height: 100%;
        .menu-bar-box {
          position: relative;
          float: right;
          width: 30px;
          height: 100%;
          .menu-bar, .menu-bar:before, .menu-bar:after {
            display: block;
            position: absolute;
            width: 100%;
            height: 3px;
            background: #888;
            z-index: 999;
          }
          .menu-bar {
            top: 50%;
            right: 0;
          }
          .menu-bar:before {
            content: ' ';
            top: -8px;
            right: 0;
          }
          .menu-bar:after {
            content: ' ';
            bottom: -8px;
            right: 0;
          }
        }
        ul.menu-list {
          display: none;
          position: absolute; // 相对与.head-contain定位
          top: 80px;
          left: 0;
          z-index: 99999;
          width: 100%;
          background: #fff;
          overflow-x: hidden;
          border-bottom: 1px solid @border-color;
          border-top: 1px solid @border-color;
          li {
            display: block;
            padding-left: 20px;
            text-align: left;
            border-bottom: 1px solid @border-color;
            ul.second-menu {
              position: static;
              opacity: 1;
              visibility: visible;
              border: none;
              li {
                border-bottom: none;
                color: #888;
                a {
                  color: #888;
                }
              }
            }
            a {
              width: 100%;
              text-align: left!important;
              text-indent: 0!important;
            }
          }
        }
      }
    }

    // 登录、注册、充值弹窗样式
    /deep/ .dialog-style {
      width: 98%;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 375px) {
    // head开始
    .head-info-bg {
      height: 51px;
      line-height: 51px;
      padding: 0 10px;
      .info-menu {
        justify-content: flex-start;
      }
      .socialmedia-widget {
        display: none;
        li {
          height: 51px;
        }
        li a {
          height: 100%;
        }
        a.mail {
          background-position: 105px top;
        }
        a.mail:hover {
          background-position: 105px bottom;
        }
        a.facebook {
          background-position: -8px top;
        }
        a.facebook:hover {
          background-position: -8px bottom;
        }
        a.twitter {
          background-position: -69px top;
        }
        a.twitter:hover {
          background-position: -69px bottom;
        }
        a.googleplus {
          background-position: 280px top;
        }
        a.googleplus:hover {
          background-position: 280px bottom;
        }
        a.youtube {
          background-position: 163px top;
        }
        a.youtube:hover {
          background-position: 163px bottom;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/headerNew.vue